export const AmountFilterText = {
  inputLabel: 'Введите сумму займа',
};
